// extracted by mini-css-extract-plugin
module.exports = {"container":"Chapter_container__1sDms","middleSection":"Chapter_middleSection__273LC"};